import './mostbook.css'
import mersial from '../newservice/image/commercial.jpg'
import interior from '../newservice/image/interior.jpeg'
import move from './image/movein.jpeg'
import leaning from './image/residentalclean.jpeg'
import commers from './image/commercialclean.jpeg'
import exterior from "../newservice/image/exterior.webp"
import leakplum from "../newservice/image/leakplum.jpeg"
import fixer from "../newservice/image/fixureinstall.jpeg"
import pipe from "../newservice/image/piperepair.jpg"
import air from './image/ac.jpeg'
import wash from './image/wash.jpeg'
import ref from './image/ref.jpeg'
import { useNavigate } from 'react-router-dom'


const services = [
  {
    name: "commersial Paint at your Loacation",
    price: 300,
    image:mersial
  },
  {
    name: "Interior your home ",
    price: 250,
    image:interior
  },
  {
    name: "Exterior painting home",
    price: 2000-20000,
    image: exterior
  },
  {
    name: "Leak Detection & Repair",
    price: 300,
    image: leakplum
  },
  {
    name: "Pipe Repair & Replacement",
    price: 250,
    image: pipe
  },
  {
    name: "Fixture Installation",
    price: 350,
    image:fixer
  },
  {
    name: "Home cleaning your Home",
    price: 250-1000,
    image: leaning
  },
  {
    name: "meve one Home to another home",
    price:1000-2000,
    image: move
  },
  {
    name: "Offices, retail spaces, and warehouses",
    price: 1000,
    image:commers
  },
  {
    name: "Ac Installation/repaire",
    price:1299,
    image: air
  },
  {
    name: "Fridge Repair Service at your Home",
    price: 300,
    image: ref
  },
  {
    name: "Washing machine repaire service at home",
    price: 300,
    image: wash
  },
];


const MostBookServi = () => {
    const navigate=useNavigate()
  return (
    <div className="service-list">
      <h2 className="text-center">Most Booked Services</h2>
      <div className="services-grid">
        {services.map((service, index) => (
          <div key={index} className="service-card">
            <img src={service.image} alt={service.name} className="service-image" />
            <div className="service-info">
              <h3>{service.name}</h3>
              <p><strong>Location:</strong> Siwan</p>
              <p><strong>Price:</strong> ₹ {service.price.toFixed(2)}</p>
              <button onClick={() => navigate('/contact')}>Book Now</button>
            </div>
          </div>
        ))}
      </div>

    </div>
  );
};
export default MostBookServi;
